// @flow
import ResourceFactory from 'app/common/lib/ResourceFactory';
import type { Thunk } from 'app/common/redux/types';
import { UserBlockTypes } from 'app/common/redux/actions/user/actionTypes';

export type UserBlock = {
  type: typeof UserBlockTypes.USER_BLOCK,
  payload: {
    id: string,
    isUserBlocked: boolean,
  },
};

const blockUser = (id: string, isUserBlocked: boolean): UserBlock => ({
  type: UserBlockTypes.USER_BLOCK,
  payload: {
    id,
    isUserBlocked,
  },
});

export const block = (id: string): Thunk<void> => (dispatch) => {
  const resource = ResourceFactory.create('UserBlockResource', {
    blocked_user_id: id,
  });
  resource.callCreate();
  dispatch(blockUser(id, true));
};

export const unblock = (id: string): Thunk<void> => (dispatch) => {
  const resource = ResourceFactory.create('UserBlockResource', {
    blocked_user_id: id,
  });
  dispatch(blockUser(id, false));
  return resource.callDelete();
};
